export var TransactionSamplingMethod;

(function (TransactionSamplingMethod) {
  TransactionSamplingMethod["Explicit"] = "explicitly_set";
  TransactionSamplingMethod["Sampler"] = "client_sampler";
  TransactionSamplingMethod["Rate"] = "client_rate";
  TransactionSamplingMethod["Inheritance"] = "inheritance";
})(TransactionSamplingMethod || (TransactionSamplingMethod = {}));